<template>
    <div id="voiceRecorder" class="px-1">
        <div v-if="!isRecording">
            <a-button class="actionBtn" @click="() => startRecord()">
                <md-icon style="color: #1e1e2d">mic</md-icon>
            </a-button>
        </div>
        <div v-else class="voice-record-phase">
            <md-button class="actionBtn" @click="() => stopRecord(true)" id="cancelBtn">
                <md-icon class="icon">delete</md-icon>
            </md-button>
            <div class="frequence">
                <av-media
                    id="av-media"
                    :media="media"
                    :type="'frequ'"
                    :canvWidth="50"
                    :canvHeight="20"
                    lineColor="white"
                    frequ-lnum="15"
                ></av-media>
            </div>
            <md-button class="actionBtn" @click="() => stopRecord()" id="doneBtn">
                <md-icon class="icon">check_circle</md-icon>
            </md-button>
        </div>
    </div>
</template>

<script>
import { getRecorder } from "./util/voiceRecorder";
import log2 from "../utils/log2";

const log = log2("VoiceRecorder");

export default {
    name: "VoiceRecorder",
    props: ["cb", "canvW", "canvH"],
    data() {
        return {
            isRecording: false,
            duration: 0,
            interval: null,
            maxSec: 60,
            media: null,
        };
    },
    methods: {
        startRecord() {
            if (this.isRecording) return;
            getRecorder().start((e) => {
                this.media = e.target.stream;
            });
            this.isRecording = true;
            this.interval = setInterval(() => this.duration++, 1000);
        },
        stopRecord(cancel = false) {
            if (!this.isRecording) return;
            getRecorder().stop(cancel ? () => {} : this.cb);
            this.isRecording = false;
            clearInterval(this.interval);
            this.duration = 0;
        },
    },
    watch: {
        duration(newVal, oldVal) {
            if (newVal >= this.maxSec) {
                getRecorder().stop(this.cb);
                this.isRecording = false;
                clearInterval(this.interval);
                this.duration = 0;
            }
        },
    },
    beforeDestroy() {
        getRecorder().stop(() => {});
        clearInterval(this.interval);
    },
};
</script>

<style lang="scss">
#voiceRecorder {
    z-index: 3;

    .actionBtn {
        min-width: 24px;
        margin: 0;
    }

    .voice-record-phase {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 3px;
        background: #e3e5e5;
        border-radius: 3rem;
        padding: 0 3px;

        #doneBtn {
            .icon {
                color: #00dfa2;
                opacity: 0.4;
            }

            &:hover,
            &:active,
            &.md-focused {
                &:before {
                    background-color: transparent;
                }

                .icon {
                    color: #00dfa2;
                    opacity: 1;
                    -ms-transform: scale(1.2);
                    -webkit-transform: scale(1.2);
                    transform: scale(1.2);
                    transition: all 0.3s ease;
                }
            }
        }

        #cancelBtn {
            .icon {
                color: #fe0000;
                opacity: 0.4;
            }

            &:hover,
            &:active,
            &.md-focused {
                &:before {
                    background-color: transparent;
                }

                .icon {
                    color: #fe0000;
                    opacity: 1;
                    -ms-transform: scale(1.2);
                    -webkit-transform: scale(1.2);
                    transform: scale(1.2);
                    transition: all 0.3s ease;
                }
            }
        }

        .frequence {
            background: rgba(78, 140, 255, 0.8);
            border-radius: 3rem;
            width: max-content;
            padding: 0 5px;
        }

        &-progress {
            margin-left: 6px;
            width: 20vw;
        }
    }

    .ant-progress-inner {
        background-color: #d9d9d9;
    }
}
</style>
<style lang="scss" scoped>
.ant-btn {
    background: transparent !important;
    border: 0px !important;
}

.dark-mode .ant-btn {
    border: 0px;
}
</style>
